import { c as _c } from "react/compiler-runtime";
import type { GiftProductApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { GiftCard } from '@/app/_components/GiftCard/GiftCard';
import { SearchEmptyResults } from '../SearchEmptyResults';
export function GiftList(t0) {
  const $ = _c(7);
  const {
    items
  } = t0;
  if (items.length < 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SearchEmptyResults />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== items) {
    let t2;
    if ($[3] !== items.length) {
      t2 = (item, idx) => <Fragment key={item.productNumber ?? item.productId}><SearchCategoryAdSlot as="li" placement="search-gift" position={idx + 1} listLength={items.length} /><li><GiftCard mainImageUrl={item.mainImageUrl} productName={item.productName} donationAmount={item.requiredDonationAmount} reviewRating={item.reviewRating} reviewCount={item.reviewCount} productNumber={item.slugId ?? item.productNumber} /></li></Fragment>;
      $[3] = items.length;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:grid-cols-2 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:px-20">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}